function storylinesToOptions(storylines) {
  if (!Array.isArray(storylines)) return [];
  return storylines.map(storyline => ({ label: storyline.name, value: storyline.id }));
}

export default storylinesToOptions;
